import { useState } from 'react'
import type { AssetDocumentsFileRow, AssetDocumentsListModel } from '@buxus/shared'
import { InlineSpinner } from './components/InlineSpinner'

function FileIcon() {
  return (
    <svg
      className="asset-documents-file-icon"
      viewBox="0 0 24 24"
      width={24}
      height={24}
      aria-hidden
    >
      <path
        fill="currentColor"
        d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm-1 2 5 5h-5V4zM6 20V4h6v6h6v10H6z"
      />
    </svg>
  )
}

type AssetDocumentsListProps = {
  model: AssetDocumentsListModel
  onOpenFile: (row: AssetDocumentsFileRow) => void | Promise<void>
  openingFileId?: string | null
}

export function AssetDocumentsList({
  model,
  onOpenFile,
  openingFileId = null,
}: AssetDocumentsListProps) {
  const [localOpeningId, setLocalOpeningId] = useState<string | null>(null)
  const busyId = openingFileId ?? localOpeningId

  const handleOpen = async (row: AssetDocumentsFileRow) => {
    if (busyId) return
    setLocalOpeningId(row.id)
    try {
      await onOpenFile(row)
    } finally {
      setLocalOpeningId(null)
    }
  }

  return (
    <article className="asset-documents">
      {model.sections.map((section) => {
        if (!section.rows.length) return null
        return (
          <section key={section.title} className="asset-documents-section">
            <h3 className="asset-documents-section-title">{section.title}</h3>
            <ul className="asset-documents-file-list">
              {section.rows.map((row) => {
                const isOpening = busyId === row.id
                return (
                  <li key={`${section.title}-${row.id}`}>
                    <button
                      type="button"
                      className="asset-documents-file-row"
                      disabled={!!busyId}
                      aria-busy={isOpening}
                      onClick={() => void handleOpen(row)}
                    >
                      <FileIcon />
                      <span className="asset-documents-file-text">
                        <span className="asset-documents-file-title">
                          {row.title}
                          {isOpening ? <InlineSpinner label="Opening file" /> : null}
                        </span>
                        {row.subtitle ? (
                          <span className="asset-documents-file-subtitle">{row.subtitle}</span>
                        ) : null}
                      </span>
                    </button>
                  </li>
                )
              })}
            </ul>
          </section>
        )
      })}
    </article>
  )
}
